import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { SiteLayout } from './components/layout/SiteLayout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Products } from './pages/Products';
import { ProductDetail } from './pages/ProductDetail';
import { Gallery } from './pages/Gallery';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rlf6csv3xo2u">
      <SiteLayout data-id="element-1" data-mp="2rit3h6j5vwqy">
        <Routes data-id="element-2" data-mp="2mlu5ue0ah7o0">
          <Route path="/" element={<Home data-id="element-4" data-mp="2mn5bkjdaophr" />} data-id="element-3" data-mp="2mmcc83go129n" />
          <Route path="/about" element={<About data-id="element-6" data-mp="31aqfgfhzusqq" />} data-id="element-5" data-mp="2mnnfm2678808" />
          <Route path="/products" element={<Products data-id="element-8" data-mp="31c9w477kb5t1" />} data-id="element-7" data-mp="31b8fzobovt4g" />
          <Route path="/products/:slug" element={<ProductDetail data-id="element-10" data-mp="2wjgtppzkg9k4" />} data-id="element-9" data-mp="31ctaxf1x1e2u" />
          <Route path="/gallery" element={<Gallery data-id="element-12" data-mp="2wi5nzkmk8rqd" />} data-id="element-11" data-mp="2wiferaffj2x4" />
          <Route path="/contact" element={<Contact data-id="element-14" data-mp="28t4m6g88geu2" />} data-id="element-13" data-mp="28u5uwe1s0p8m" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-16" data-mp="23vcjcr61v8b3" />} data-id="element-15" data-mp="28sl5f2ubjwhm" />
        </Routes>
      </SiteLayout>
    </BrowserRouter>;
}